import "./App.css";
import React, { lazy, Suspense, useMemo } from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { createContext } from "react";
import { useEffect, useState } from "react";
import { GetLocalStorage } from "./Helpers/LocalStorage/LocalStorage";
import { useSetLoginInfo } from "./Helpers/CustomHooks/CheckLogin";
// import WhatsAppFloatingButton from "./Components/WhatsAppFloatingButton/WhatsAppFloatingButton";
// import InitiatedClassOtpPopup from "./Components/InitiatedClassOtpPopup/InitiatedClassOtpPopup";
import LoginAndRegister from "./Pages/LoginAndRegister/LoginAndRegister";
// import CourseTracker from "./Pages/CourseTracker/CourseTracker";
// import FindCourseFloatingButton from "./Components/FindCourseFloatingButton/FindCourseFloatingButton";
import { useAppSocket } from "./app-effects/useAppSocket";
import { useLearnerOTPWatcher } from "./app-effects/useLearnerOTPWatcher";
// import { ErrorRoutes } from "./Routes/ErrorRoutes";
import PublicRoutes from "./Routes/PublicRoutes";
import VLIAdminRoutes from "./Routes/VLIAdminRoutes";
import LearnerRoutes from "./Routes/LearnerRoutes";
import InstructorRoutes from "./Routes/InstructorRoutes";
import InstituteRoutes from "./Routes/InstituteRoutes";
import { useLocation } from "react-router-dom";
import Header from "./Components/Header/Headers";
import LoadingSpinner from "./Components/LoadingSpinner/LoadingSpinner";
import { usePostHog } from '@posthog/react'
import LandingPage from "./Pages/LandingPage/LandingPage";
import Page404 from "./Pages/Page404/Page404";

const AdminNewDashboard = lazy(() =>import("./Pages/AdminNew/index"));
const InstituteDashboard = lazy(() => import("./Pages/InstituteDashboard/InstituteDashboard"));
// const LoginAndRegister = lazy(() => import("./Pages/LoginAndRegister/LoginAndRegister"));
const WhatsAppFloatingButton = lazy(() => import("./Components/WhatsAppFloatingButton/WhatsAppFloatingButton"));
const FindCourseFloatingButton = lazy(() => import("./Components/FindCourseFloatingButton/FindCourseFloatingButton"));
const CourseTracker = lazy(() => import("./Pages/CourseTracker/CourseTracker"));
const InitiatedClassOtpPopup = lazy(() => import("./Components/InitiatedClassOtpPopup/InitiatedClassOtpPopup"));

// const ErrorRoutes = React.lazy(() => import("./Routes/ErrorRoutes"));
// const PublicRoutes = React.lazy(() => import("./Routes/PublicRoutes"));
// const LearnerRoutes = React.lazy(() => import("./Routes/LearnerRoutes"));
// const VLIAdminRoutes = React.lazy(() => import("./Routes/VLIAdminRoutes"));
// const InstructorRoutes = React.lazy(() => import("./Routes/InstructorRoutes"));
// const InstituteRoutes = React.lazy(() => import("./Routes/InstituteRoutes"));

export const SocketContext = createContext();

function App() {
  const [setAuthPageName] = useState("");
  const [showFindCourseBtn, setShowFindCourseBtn] = useState(false);
  // const { AuthPageName } = useSelector((Store) => Store.ToggleSignupReducer);
  // const { UserInfo } = useSelector((store) => store.LoginSignupReducer);
  const location = useLocation();

  const posthog = usePostHog();
  const isProduction = window.location.hostname === "vehiclelearning.com";

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowFindCourseBtn(true);
    }, 5000); // delay (you can adjust)
  
    return () => clearTimeout(timer);
  }, []);

  const { AuthPageName, UserInfo } = useSelector((store) => ({
    AuthPageName: store.ToggleSignupReducer.AuthPageName,
    UserInfo: store.LoginSignupReducer.UserInfo,
  }));
  console.log("UserInfo  is in appp:", UserInfo);

   useEffect(() => {
    if (!isProduction) {
      posthog.opt_out_capturing();

      return;
    }

    if (UserInfo?.UserId) {
      posthog.identify(UserInfo.UserId, {
        name: UserInfo?.FirstName || "",
        email: UserInfo?.Email || "",
        role: UserInfo?.InstituteUserType || "",
      })
    }
  }, [UserInfo])

  useEffect(() => {
    if (!isProduction) return;

  posthog.capture('$pageview', {
    userId: UserInfo?.UserId || "anonymous",
    name: UserInfo?.name || "guest",
    role: UserInfo?.InstituteUserType || "guest",
    page: location.pathname
  })
  }, [location, UserInfo])

  const Socket = useAppSocket(UserInfo);

  // const UserType = GetLocalStorage("UserInfo")?.User;
  // const InstituteUserType = GetLocalStorage("UserInfo")?.InstituteUserType;
  // const UserId = GetLocalStorage("UserInfo")?.UserId;
  // console.log("UserId is:", UserId);

  // const userInfo = GetLocalStorage("UserInfo");

  const UserType = UserInfo?.User;
  const InstituteUserType = UserInfo?.InstituteUserType;
  const UserId = UserInfo?.UserId;

  useSetLoginInfo();

  // const Home =
  //   !UserInfo?.User || UserInfo?.User === "Student" ? (
  //     <LandingPage />
  //   ) : UserInfo?.User === "Admin" ? (
  //     <AdminNewDashboard />
  //   ) : UserInfo?.User === "Institute" ? (
  //     <InstituteDashboard />
  //   ) : (
  //     <LandingPage />
  //   );

  const Home = useMemo(() => {
    if (!UserInfo?.User || UserInfo?.User === "Student") {
      return <LandingPage />;
    }
    if (UserInfo?.User === "Admin") {
      return <AdminNewDashboard />;
    }
    if (UserInfo?.User === "Institute") {
      return <InstituteDashboard />;
    }
    return <LandingPage />;
  }, [UserInfo]);

  const { showPopup, otp, closePopup } = useLearnerOTPWatcher(UserId, UserType);

  // const allowedRoutes = [
  //   "/",
  //   "/about",
  //   "/get-ready",
  //   "/get-ready/knowledge-test",
  //   "/get-ready/knowledge-test-selection",
  //   "/vli-blogs",
  //   "/course",
  // ];

  const allowedRoutes = useMemo(() => [
    "/",
    "/about",
    "/get-ready",
    "/get-ready/knowledge-test",
    "/get-ready/knowledge-test-quiz",
    "/get-ready/quiz",
    "/vli-blogs",
    "/course",
  ], []);

  // const allRoutes = useMemo(() => {
  //   return (
  //     <>
  //       {/* {ErrorRoutes} */}
  //       <PublicRoutes />
  //       {UserInfo?.User === "Admin" && <VLIAdminRoutes />}
  //       {UserInfo?.User === "Student" && <LearnerRoutes />}
  //       {(UserInfo?.User === "Institute" &&
  //         UserInfo?.InstituteUserType === "Instructor") &&
  //         <InstructorRoutes />}
  //       {(UserInfo?.User === "Institute" &&
  //         UserInfo?.InstituteUserType !== "Instructor") &&
  //         <InstituteRoutes />}
  //     </>
  //   );
  // }, [UserInfo]);

  const allRoutes = useMemo(() => {
  return (
    <Routes>
      <Route path="/" element={Home} />
      
      {/* ✅ Call as function, not as component */}
      {PublicRoutes()}
      {UserInfo?.User === "Admin" && VLIAdminRoutes()}
      {UserInfo?.User === "Student" && LearnerRoutes()}
      {UserInfo?.User === "Institute" && UserInfo?.InstituteUserType === "Instructor" && InstructorRoutes()}
      {UserInfo?.User === "Institute" && UserInfo?.InstituteUserType !== "Instructor" && InstituteRoutes()} 

      <Route path="*" element={<Page404 />} />
    </Routes>
  );
}, [UserInfo, Home]);

  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "/fonts.css";
    document.head.appendChild(link);
  }, []);

  window.addEventListener("error", (e) => {
    if (e.message.includes("Loading chunk")) {
      window.location.reload();
    }
  });
  
  return (
    <SocketContext.Provider value={Socket}>
     
        <Header AuthPageName={AuthPageName} setAuthPageName={setAuthPageName} />

        {showPopup && <InitiatedClassOtpPopup otp={otp} setShowPopup={closePopup} />}

        {AuthPageName !== "" ? <LoginAndRegister /> : null}
        <CourseTracker />

        <Suspense fallback={<LoadingSpinner
              Height="[500px]"
              Width="[99%]"
              Top="[80px]"
              Left="0"
              Position="relative"
            />}>
          <div key={location.pathname}>
            {/* <Routes>
              <Route path="/" element={Home} />
            </Routes> */}
            {allRoutes}
          </div>

            {/*
            {PublicRoutes()}
            // VLI Admin 
            {UserInfo?.User === "Admin" && VLIAdminRoutes()}

            // Learner / Student 
            {UserInfo?.User === "Student" && LearnerRoutes()}

            // Instructor 
            {(UserInfo?.User === "Institute" &&
              UserInfo?.InstituteUserType === "Instructor") &&
              InstructorRoutes()}

            // Institute (non-instructor) 
            {(UserInfo?.User === "Institute" &&
              UserInfo?.InstituteUserType !== "Instructor") &&
              InstituteRoutes()}
  */}
         
        </Suspense>

        {(
            !UserInfo?.User ||
            UserInfo?.User === "Student"
        ) && <WhatsAppFloatingButton />}

      {(
        showFindCourseBtn &&
        (!UserInfo?.User || UserInfo?.User === "Student") &&
        allowedRoutes.includes(location.pathname)
      ) && <FindCourseFloatingButton />} 

     </SocketContext.Provider>
  );
}

export default App;

